import { Link } from 'react-router-dom';
import { FiArrowRight, FiChevronDown } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';
import styles from './LandingPage.module.css';

const LandingPage = () => {
  const { theme } = useTheme();
  const logoSrc = theme === 'black' ? '/JainamSevaSetuDark.png' : '/JainamSevaSetuLight.png';

  const scrollDown = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <div className={styles.heroText}>
          <div className={styles.heroBadge}>Jain Community Platform</div>
          <img src={logoSrc} alt="JainamSevaSetu" className={styles.heroLogo} />
          <h1 className={styles.heroTitle}>
            <span className={styles.heroBlue}>Jainam</span>
            <span className={styles.heroGold}>Seva</span>
            <span className={styles.heroBlue}>Setu</span>
          </h1>
          <p className={styles.heroSubtitle}>
            A unified digital platform for Jain Derasars to manage donations,
            track donation offers, organise families, and maintain complete financial records.
          </p>
          <div className={styles.heroActions}>
            <Link to="/login/admin?tab=register" className={styles.btnHeroAdmin}>
              Register Your Derasar <FiArrowRight size={16} />
            </Link>
            <Link to="/login?tab=register" className={styles.btnHeroMember}>
              Join as Member
            </Link>
          </div>
        </div>
      </div>
      <button className={styles.scrollHint} onClick={scrollDown} aria-label="Scroll down">
        <FiChevronDown size={22} />
      </button>
    </section>
  );
};

export default LandingPage;
